import { ReactElement } from 'react';
import { useTranslation } from 'next-i18next';
import { IGetPromotionResponse } from '@Hotels-at-Home/hah-fe-core/dist/types';
import classnames from 'classnames';

interface IProps {
  promotion: IGetPromotionResponse;
  daysLeft: null | number;
  ends: string;
  currency: string;
}

const BmsmChart = ({ promotion, daysLeft, ends, currency }: IProps): ReactElement => {
  const { t } = useTranslation('', { keyPrefix: '$local.$bmsmChart' });
  const { t: tPromo } = useTranslation('', { keyPrefix: '$common.$promotion' });

  const countdownIsActive = daysLeft <= 3;

  const countdownClass = (() => {
    if (daysLeft !== null && countdownIsActive) {
      if (daysLeft >= 0 && daysLeft < 1) {
        return 'ends-today';
      }
      if (daysLeft >= 1 && daysLeft < 2) {
        return 'ends-tomorrow';
      }
      if (daysLeft >= 2 && daysLeft < 3) {
        return 'ends-date';
      }
    }
    return '';
  })();

  const countdownCopy = (() => {
    if (daysLeft !== null && countdownIsActive) {
      if (daysLeft >= 0 && daysLeft < 1) {
        return 'hpEndsToday';
      }
      if (daysLeft >= 1 && daysLeft < 2) {
        return 'endsTomorrow';
      }
      if (daysLeft >= 2 && daysLeft < 3) {
        return 'ends';
      }
    }
    return '';
  })();

  return (
    <div className="stack">
      <div className="bmsm-chart">
        <span className={classnames('bmsm-countdown chart-headline-countdown', countdownClass)}>
          {countdownCopy && tPromo(countdownCopy, { ends: tPromo(ends) })}
          {countdownCopy !== '' ? '*' : ''}
        </span>
        <h2 className="bmsm-title">{t('title')}</h2>
        <table>
          <tbody>
            <tr>
              <td className="bmsm-header" />
            </tr>
            <tr>
              <td className="spend-header spend-col">{t('spend')}</td>
              <td className="save-header save-col">{t('save')}</td>
            </tr>
            {currency !== 'GBP' ? (
              <>
                <tr>
                  <td className="spend-col">{t('spend_1')}</td>
                  <td className="save-col">{t('save_1')}</td>
                </tr>
                <tr>
                  <td className="spend-col">{t('spend_2')}</td>
                  <td className="save-col">{t('save_2')}</td>
                </tr>
                <tr>
                  <td className="spend-col">{t('spend_3')}</td>
                  <td className="save-col">{t('save_3')}</td>
                </tr>
                <tr>
                  <td className="spend-col">{t('spend_4')}</td>
                  <td className="save-col">{t('save_4')}</td>
                </tr>
                <tr>
                  <td className="spend-col">{t('spend_5')}</td>
                  <td className="save-col">{t('save_5')}</td>
                </tr>
              </>
            ) : (
              <>
                <tr>
                  <td className="spend-col">£4,000</td>
                  <td className="save-col">£1,500 OFF</td>
                </tr>
                <tr>
                  <td className="spend-col">£2,500</td>
                  <td className="save-col">£750 OFF</td>
                </tr>
                <tr>
                  <td className="spend-col">£1,500</td>
                  <td className="save-col">£400 OFF</td>
                </tr>
                <tr>
                  <td className="spend-col">£500</td>
                  <td className="save-col">£100 OFF</td>
                </tr>
                <tr>
                  <td className="spend-col">£200</td>
                  <td className="save-col">£25 OFF</td>
                </tr>
              </>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default BmsmChart;
